"use strict";

exports.__esModule = true;
exports.SortButton = exports.SORT_ORDER = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _excluded = ["sortOrder", "onSort"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var SORT_ORDER = exports.SORT_ORDER = {
  asc: "desc",
  desc: "none",
  none: "asc"
};
var SORT_ICON = {
  asc: _icons.IconNames.SORT_ALPHABETICAL,
  desc: _icons.IconNames.SORT_ALPHABETICAL_DESC,
  none: _icons.IconNames.SORT
};
var SortButton = exports.SortButton = /*#__PURE__*/function (_Component) {
  function SortButton() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(SortButton, _Component);
  var _proto = SortButton.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      sortOrder = _this$props.sortOrder,
      onSort = _this$props.onSort,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({
      title: "Sort"
    }, extra, {
      icon: SORT_ICON[SORT_ORDER[sortOrder]],
      onClick: function onClick() {
        return onSort(SORT_ORDER[sortOrder]);
      }
    }));
  };
  return SortButton;
}(_react.Component);
SortButton.defaultProps = {
  sortOrder: SORT_ORDER.none
};